import { useEffect, useState } from "react";

export function useIsPortrait(aspect = 1.05): boolean {
  const measure = () => {
    if (typeof window === "undefined") return false;
    const w = window.innerWidth, h = window.innerHeight;
    return w > 0 && h > 0 ? h / w >= aspect : false;
  };

  const [portrait, setPortrait] = useState(measure);   // ← lazy initial = correct on first render

  useEffect(() => {
    const check = () => setPortrait(measure());
    check();
    window.addEventListener("resize", check);
    window.addEventListener("orientationchange", check);
    return () => {
      window.removeEventListener("resize", check);
      window.removeEventListener("orientationchange", check);
    };
  }, [aspect]);   // measure() reads window fresh each call; safe to omit from deps

  return portrait;
}

export default useIsPortrait;